<template>
    <v-combobox v-model="model" id="infinite-list"
        :items="items" 
        :item-text="itemText"
        :item-value="itemValue"
        :autofocus="autofocus"
        @keydown.space.prevent
        hide-details
        :placeholder="childplaceholder" 
        :clearable="clearable"
        class="form-control form-control-sm" :class="childclass">
    </v-combobox>
</template>
<script>
export default {
    props: {
        itemText: '',
        itemValue: '',
        endpoint: '',
        childplaceholder: '',
        childclass: '',
        clearable: false,
        autofocus: false
    },
    data(){
        return{
            loading: false,
            items: [],
            page: 0,
            end_page: 1
        }
    },
    computed: {
        model: {
            get: function() {
                return this.$attrs.value
            },
            set: function(value) {
                let vue = this
                vue.data = []
                vue.loading = false
                if(value){
                    vue.$emit('input', value[vue.itemValue])
                }else{
                    vue.$emit('input', null)
                }
            }
        }
    },
    mounted() {
        this.DATA()
    },
    methods: {
        DATA: function () {
            let vue = this
            vue.page++
            axios({
                url: vue.endpoint + '?page=' + vue.page,
                method: 'GET'
            })
                .then((resp) => {
                    vue.items = [
                        ...vue.items,
                        ...resp.data.data
                    ]
                    vue.end_page = resp.data.last_page
                })
                .catch((err) => {
                    if (err.response.status === 402) {
                       let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    } else {
                        vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }
                })
                .finally((resp) => {
                    while (vue.page <= vue.end_page) {
                        vue.DATA()
                    }
                })
        },
    }
}
</script>